import { ComponentPropsOptions, h } from '@vue/composition-api';
import { NodeProps, ValidConnectionFunc } from '../../types';
import { Position } from '../../types';
import { defineComponent } from '@vue/composition-api';
import { Fragment } from 'vue-frag';
import { PropType } from 'vue';
import { IWorkflowState } from '@/models';
import Handle from '../handle/Handle.vue';
import NodeLabel from './NodeLabel';

const OutputNode = defineComponent<Partial<NodeProps<IWorkflowState>>>({
  name: 'OutputNode',

  components: {
    Fragment
  },

  props: {
    targetPosition: {
      type: String,
      default: () => Position.Top
    },

    connectable: {
      type: Boolean,
      default: true
    },

    selected: {
      type: Boolean
    },

    isValidSourcePos: {
      type: Function as PropType<ValidConnectionFunc>
    },
    data: {
      type: Object as PropType<IWorkflowState>,
      default: () => ({})
    }
  } as ComponentPropsOptions<Partial<NodeProps<IWorkflowState>>>,

  setup(props, _context) {
    return () =>
      h(Fragment, [
        h(Handle, {
          attrs: {
            type: 'target',
            position: props.targetPosition,
            connectable: props.connectable,
            isValidConnection: props.isValidTargetPos
          }
        }),
        h(NodeLabel, { props })
      ]);
  }
});

export default OutputNode;
